import React, { useState, useEffect } from "react";
import Item from "./Item";
import Machine from "./Mch";
import Process from "./Process";
import * as s from "./styles";
import Confirmation from "../Confirmation";
import {
  Alert,
  Snackbar,
  Typography,
  ToggleButtonGroup,
  ToggleButton,
} from "@mui/material";
import { useGetTableData2 } from "../Plan/tableHooks";
import { useParams } from "react-router-dom";
import StarHalfIcon from "@mui/icons-material/StarHalf";
import StarIcon from "@mui/icons-material/Star";
import SemiItem from "./Semi-Item";
import { useInsightwinProcessMaster } from "./hooks";

// 기준정보 - 아이템관리 페이지
function InformationForViewer() {
  const { group_code, project_code } = useParams();
  const [clickedItemId, setClickedItemId] = useState(0);
  const [clickedProcId, setClickedProcId] = useState(0);
  const [viewMode, setViewMode] = useState("item");
  const { processMasterData, orderData } = useInsightwinProcessMaster(
    clickedProcId,
    group_code,
    project_code
  );
  const [confirmationConfig, setConfirmationConfig] = useState({
    isOpen: false,
    title: "",
    mainText: "",
    subText: "",
    onConfirm: () => {},
  });
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success", // 'success', 'error', 'warning', 'info'
  });
  const { data, isLoading, isFetching } = useGetTableData2(
    null,
    `/api/item/getAllItems?group_code=${group_code}&project_code=${project_code}`
  );
  const openSnackbar = (message, severity = "success") => {
    setSnackbar({
      open: true,
      message,
      severity,
    });
  };
  const closeSnackbar = () => {
    setSnackbar({
      ...snackbar,
      open: false,
    });
  };
  const handleShowConfirmation = (config) => {
    setConfirmationConfig({
      isOpen: true,
      ...config,
    });
  };
  const handleCloseConfirmation = () => {
    setConfirmationConfig((prev) => ({
      ...prev,
      isOpen: false,
    }));
  };
  const handleViewModeChange = (event, newMode) => {
    if (newMode !== null) {
      setViewMode(newMode);
      setClickedItemId(0);
      setClickedProcId(0);
      openSnackbar(
        `${newMode === "item" ? "완제품" : "반제품"} 모드로 전환됩니다.`,
        "success"
      );
    }
  };
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "unset";
    };
  }, []);
  return (
    <>
      <s.ContainerViewer>
        <s.ToolbarContainer>
          <s.ToolbarLeft>
            <Typography
              variant="h5"
              fontWeight={700}
              sx={{ fontSize: "22px !important", color: "#111" }}
            >
              제품 관리
            </Typography>
          </s.ToolbarLeft>
          <s.ToolbarRight>
            <ToggleButtonGroup
              value={viewMode}
              exclusive
              onChange={handleViewModeChange}
              size="small"
              sx={{ mx: 1 }}
            >
              <ToggleButton value="item" aria-label="완제품 보기">
                <StarIcon fontSize="small" />
              </ToggleButton>
              <ToggleButton value="semi" aria-label="반제품 보기">
                <StarHalfIcon fontSize="small" />
              </ToggleButton>
            </ToggleButtonGroup>
            {/* <Tooltip title="도움말">
          <IconButton size="small">
            <HelpOutlineIcon fontSize="small" />
          </IconButton>
        </Tooltip> */}
          </s.ToolbarRight>
        </s.ToolbarContainer>
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            gap: "1.4rem",
            height: "100%",
            alignItems: "center",
            padding: "0 1rem",
          }}
        >
          {/* asdf ㅁㅇㄴ 반제품/완제품 토글버튼. Item 부분에. 
         clicked state  초기화 중요.   */}
          <s.Section>
            <s.SectionContent>
              {viewMode === "item" ? (
                <Item
                  setClickedItemId={setClickedItemId}
                  clickedItemId={clickedItemId}
                  setClickedProcId={setClickedProcId}
                  orderData={orderData}
                  onShowConfirmation={handleShowConfirmation}
                  openSnackbar={openSnackbar}
                  itemData={data.filter((i) => i.item_type === 1)}
                />
              ) : (
                <SemiItem
                  setClickedItemId={setClickedItemId}
                  clickedItemId={clickedItemId}
                  setClickedProcId={setClickedProcId}
                  orderData={orderData}
                  onShowConfirmation={handleShowConfirmation}
                  openSnackbar={openSnackbar}
                  itemData={data.filter((i) => i.item_type === 0)}
                />
              )}
            </s.SectionContent>
          </s.Section>
          <s.Section>
            <s.SectionContent>
              <Process
                clickedItemId={clickedItemId}
                clickedProcId={clickedProcId}
                setClickedProcId={setClickedProcId}
                orderData={orderData}
                onShowConfirmation={handleShowConfirmation}
                openSnackbar={openSnackbar}
              />
            </s.SectionContent>
          </s.Section>
          <s.Section>
            <s.SectionContent>
              <Machine
                clickedItemId={clickedItemId}
                clickedProcId={clickedProcId}
                processMasterData={processMasterData}
                onShowConfirmation={handleShowConfirmation}
                openSnackbar={openSnackbar}
                orderData={orderData}
                itemData={data}
              />
            </s.SectionContent>
          </s.Section>
        </div>
      </s.ContainerViewer>
      <Confirmation
        isOpen={confirmationConfig.isOpen}
        onClose={handleCloseConfirmation}
        onConfirm={confirmationConfig.onConfirm}
        title={confirmationConfig.title}
        mainText={confirmationConfig.mainText}
        subText={confirmationConfig.subText}
      />
      <Snackbar
        open={snackbar.open}
        autoHideDuration={2000}
        onClose={closeSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={closeSnackbar}
          severity={snackbar.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
}

export default InformationForViewer;
